// extracted by mini-css-extract-plugin
export default {"grid":"Portfolio_grid__gQFo8","gridItem":"Portfolio_gridItem__95Nr+"};